var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.32 30.89"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 .29a1 1 0 00-1.41 0L.28 14.63a.94.94 0 00-.27.82.93.93 0 00.27.81L14.62 30.6a1 1 0 001.41 0 1 1 0 000-1.41L2.29 15.45 16 1.71a1 1 0 000-1.42z",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }))));
}

export default SvgBack;